import { getEl, classHelper } from '@/scripts/utils/legacy-dom.js';

(() => {
    try {
        function ingredientsOverlayPosition() {
            var isActive = getEl('.pdp-ingredients-overlay.active');
            if (!isActive) {
                return;
            }

            var overlay = getEl('.pdp-ingredients-overlay');
            if (!overlay) {
                return;
            }

            overlay.style.top = window.scrollY + 'px';
        }

        function ingredientsOverlayResize() {
            ingredientsOverlayPosition();
        }

        function ingredientsOverlayActivate(show) {
            var overlay = getEl('.pdp-ingredients-overlay');
            var body = getEl('body');

            if (!show) {
                classHelper(body, 'r', 'no-scroll');
                classHelper(overlay, 'r', 'active');
                return;
            }

            classHelper(body, 'a', 'no-scroll');
            classHelper(overlay, 'a', 'active');
            ingredientsOverlayPosition();

            (() => {
                var backTop = getEl('#back-top');
                if (!backTop) {
                    return;
                }

                if (backTop.style.display && backTop.style.display.indexOf('inline') > -1) {
                    backTop.style.display = 'none';
                }
            })();

            getEl('.pdp-ingredients-overlay .close span').addEventListener('click', function () {
                ingredientsOverlayActivate();
            })
        }

        function ingredientsOverlay() {
            var links = getEl('.pdp-ingredients-overlay-link', 1);
            if (!links) {
                return;
            }

            if (!links?.length) {
                return;
            }

            for (var i = 0; i < links.length; i++) {
                var link = links[i];
                if (!link) {
                    continue;
                }


                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    ingredientsOverlayActivate(1);
                });
            }

            window.addEventListener('resize', ingredientsOverlayResize);
        }

        if (document.readyState !== 'loading') {
            ingredientsOverlay();
        } else {
            document.addEventListener('DOMContentLoaded', ingredientsOverlay);
        }
    } catch (error) {}
})()
